import { render, staticRenderFns } from "./contentModule.vue?vue&type=template&id=332143e0&scoped=true"
import script from "./contentModule.vue?vue&type=script&lang=js"
export * from "./contentModule.vue?vue&type=script&lang=js"
import style0 from "./contentModule.vue?vue&type=style&index=0&id=332143e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332143e0",
  null
  
)

export default component.exports